/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CalendarStrictHttpResponse } from '../../calendar-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface PractitionerFindrLobbyBookingIdGet$Params {
  bookingId: string;
}

export function practitionerFindrLobbyBookingIdGet(http: HttpClient, rootUrl: string, params: PractitionerFindrLobbyBookingIdGet$Params, context?: HttpContext): Observable<CalendarStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, practitionerFindrLobbyBookingIdGet.PATH, 'get');
  if (params) {
    rb.path('bookingId', params.bookingId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CalendarStrictHttpResponse<string>;
    })
  );
}

practitionerFindrLobbyBookingIdGet.PATH = '/PractitionerFindr/Lobby/{bookingId}';
